<ui-auth-layout [showLanguageSelector]="false">
  <span class="auth-badge auth-badge--alert">
    <ui-svg-icon svgIcon="wrench-cc" size="small"></ui-svg-icon>
    Maintenance in progress
  </span>

  <div class="auth-heading">
    <h1 class="auth-heading__title">{{ title }}</h1>
    <p class="auth-heading__subtitle">{{ subtitle }}</p>
  </div>

  <p class="maintenance-page__eta">{{ eta }}</p>

  <p class="maintenance-page__footer">{{ footer }}</p>
</ui-auth-layout>
